const config = {
  url: '/action-types',
  title: 'Типы мероприятий',
  endpoint: '/admin-search?filter=action_types',
  type: 'table',
  getUrl: id => `/action-type/${id}`,
  getApiUrl: id => `/action-types/${id}`,
  search: true,
  key: 'action-types',
  access: ['*'],
  table: [
    {
      key: 'id',
      width: 75,
      title: 'ID',
      sorter: true,
      isViewByDefault: true,
      getValue: data => data.id
    },
    {
      key: 'name',
      width: 150,
      title: 'Название',
      sorter: true,
      isViewByDefault: true,
      getValue: data => data.name,
      edit: {
        component: 'Input',
        placeholder: 'Введите',
        maxLength: 255,
        required: true,
      },

    },
  ],
  filters: [],
}

export default config
